"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setFaqs = exports.selectFAQByID = exports.selectUnansweredFaqs = exports.selectArchivedFaqs = exports.selectAnsweredFaqs = exports.selectTags = exports.selectAllTeams = exports.selectAllFaqsForMobileApp = exports.selectAllFaqsWithCategories = exports.selectAllFaqs = exports.helpfulKnowledge = exports.archiveKnowledge = exports.deleteKnowledge = exports.updateKnowledge = exports.createKnowledge = exports.faqStorageConfig = exports.faqSliceConfig = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var firestore_1 = require("firebase/firestore");
var storage_1 = require("firebase/storage");
var uuid_1 = require("uuid");
var moment_1 = __importDefault(require("moment"));
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var teamSlice_1 = require("./teamSlice");
var settingSlice_1 = require("./settingSlice");
var firebaseApp;
var firestore;
var storage;
var faqSliceConfig = function (_firebaseApp) {
    firebaseApp = _firebaseApp;
    firestore = (0, firestore_1.getFirestore)(_firebaseApp);
};
exports.faqSliceConfig = faqSliceConfig;
var faqStorageConfig = function (storageBucketConfig) {
    // console.log('faqStorageConfig', storageBucketConfig.knowledge);
    var faqStorageBucket = storageBucketConfig.knowledge;
    storage = (0, storage_1.getStorage)(firebaseApp, faqStorageBucket);
};
exports.faqStorageConfig = faqStorageConfig;
// CRUD - Create, Read, Update, Delete
exports.createKnowledge = (0, toolkit_1.createAsyncThunk)('knowledge/create', function (faq, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var state, imageFiles, videoFiles, knowledge, companyID, company, displayName, uid, data, baseFAQColRef, faqDocRef, uploadMedia, imageUploaded, videoUploaded;
    var _a, _b, _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                state = thunkAPI.getState();
                imageFiles = faq.imageFiles, videoFiles = faq.videoFiles, knowledge = __rest(faq, ["imageFiles", "videoFiles"]);
                companyID = state.setting.activeWorkspaceID;
                company = state.workspace.workspaces.find(function (x) { return x.id === companyID; });
                displayName = (_a = state.me.account) === null || _a === void 0 ? void 0 : _a.displayName;
                uid = (_c = (_b = state.me.details) === null || _b === void 0 ? void 0 : _b.uid) !== null && _c !== void 0 ? _c : '';
                data = __assign(__assign({}, knowledge), { companyID: companyID, companyName: (_d = company === null || company === void 0 ? void 0 : company.name) !== null && _d !== void 0 ? _d : '', branches: faq.branches.map(function (team) { return team.teamId; }), videos: [], images: [], helpfulNo: [], helpfulYes: [], isArchived: false, displayName: displayName !== null && displayName !== void 0 ? displayName : '', createdAt: firestore_1.Timestamp.now(), createdBy: uid, createdByDisplayName: displayName !== null && displayName !== void 0 ? displayName : '', updatedAt: firestore_1.Timestamp.now(), updatedBy: uid, updatedByDisplayName: displayName !== null && displayName !== void 0 ? displayName : '' });
                baseFAQColRef = (0, firestore_1.collection)(firestore, 'companies', companyID, 'faqs');
                faqDocRef = (0, firestore_1.doc)(baseFAQColRef);
                return [4 /*yield*/, (0, firestore_1.setDoc)(faqDocRef, data)];
            case 1:
                _e.sent();
                uploadMedia = function (file) { return __awaiter(void 0, void 0, void 0, function () {
                    var uuidName, ext, baseStorageRef, uploadTask, url, result;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!file) return [3 /*break*/, 3];
                                uuidName = (0, uuid_1.v4)();
                                ext = file.name.slice(file.name.lastIndexOf('.'));
                                baseStorageRef = (0, storage_1.ref)(storage, "/".concat(companyID, "/").concat(faqDocRef.id, "/").concat(uuidName).concat(ext));
                                return [4 /*yield*/, (0, storage_1.uploadBytes)(baseStorageRef, file, { contentType: file.type })];
                            case 1:
                                uploadTask = _a.sent();
                                return [4 /*yield*/, (0, storage_1.getDownloadURL)(uploadTask.ref)];
                            case 2:
                                url = _a.sent();
                                result = { fileName: uuidName, url: url, caption: '', thumbnailUrl: '' };
                                return [2 /*return*/, result];
                            case 3: return [2 /*return*/];
                        }
                    });
                }); };
                if (!imageFiles) return [3 /*break*/, 4];
                return [4 /*yield*/, Promise.all(imageFiles.map(uploadMedia))];
            case 2:
                imageUploaded = _e.sent();
                console.log('imageUploaded', imageUploaded);
                return [4 /*yield*/, (0, firestore_1.updateDoc)(faqDocRef, { images: imageUploaded.map(function (img) { return img === null || img === void 0 ? void 0 : img.url; }) })];
            case 3:
                _e.sent();
                _e.label = 4;
            case 4:
                if (!videoFiles) return [3 /*break*/, 7];
                return [4 /*yield*/, Promise.all(videoFiles.map(uploadMedia))];
            case 5:
                videoUploaded = _e.sent();
                console.log('videoUploaded', videoUploaded);
                return [4 /*yield*/, (0, firestore_1.updateDoc)(faqDocRef, { videos: videoUploaded })];
            case 6:
                _e.sent();
                _e.label = 7;
            case 7: return [2 /*return*/];
        }
    });
}); });
exports.updateKnowledge = (0, toolkit_1.createAsyncThunk)('knowledge/update', function (arg, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var state, knowledge, images, videos, companyID, uid, displayName, faqId, branches, updateData, data, baseFAQColRef, faqDocRef, uploadMedia, unchangeImages, addImages, deleteImages, err_1, createImages, addedImages, newImages, unchangeVideos, addVideos, deleteVideos, err_2, createVideos, addedVideos, newVideos, faqData, err_3;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                state = thunkAPI.getState();
                knowledge = arg.knowledge, images = arg.images, videos = arg.videos;
                companyID = state.setting.activeWorkspaceID;
                uid = (_a = state.me.details) === null || _a === void 0 ? void 0 : _a.uid;
                displayName = (_c = (_b = state.me.account) === null || _b === void 0 ? void 0 : _b.displayName) !== null && _c !== void 0 ? _c : '';
                faqId = knowledge.faqId, branches = knowledge.branches, updateData = __rest(knowledge, ["faqId", "branches"]);
                data = __assign(__assign({ branches: branches.map(function (team) { return team.teamId; }) }, updateData), { updatedAt: firestore_1.Timestamp.now(), updatedBy: uid, updatedByDisplayName: displayName !== null && displayName !== void 0 ? displayName : '' });
                baseFAQColRef = (0, firestore_1.collection)(firestore, 'companies', companyID, 'faqs');
                faqDocRef = (0, firestore_1.doc)(baseFAQColRef, faqId);
                uploadMedia = function (file) { return __awaiter(void 0, void 0, void 0, function () {
                    var uuidName, ext, baseStorageRef, uploadTask, url, result;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!file) return [3 /*break*/, 3];
                                uuidName = (0, uuid_1.v4)();
                                ext = file.name.slice(file.name.lastIndexOf('.'));
                                baseStorageRef = (0, storage_1.ref)(storage, "/".concat(companyID, "/").concat(faqId, "/").concat(uuidName).concat(ext));
                                return [4 /*yield*/, (0, storage_1.uploadBytes)(baseStorageRef, file, { contentType: file.type })];
                            case 1:
                                uploadTask = _a.sent();
                                return [4 /*yield*/, (0, storage_1.getDownloadURL)(uploadTask.ref)];
                            case 2:
                                url = _a.sent();
                                result = { fileName: uuidName, url: url, caption: '', thumbnailUrl: '' };
                                return [2 /*return*/, result];
                            case 3: return [2 /*return*/];
                        }
                    });
                }); };
                unchangeImages = images.filter(function (image) { return image.action === 'UNCHANGE'; }).map(function (image) { return image.url; });
                addImages = images.filter(function (image) { return image.action === 'ADD'; });
                deleteImages = images.filter(function (image) { return image.action === 'REMOVE'; }).map(function (image) { return image.url; });
                _d.label = 1;
            case 1:
                _d.trys.push([1, 3, , 4]);
                return [4 /*yield*/, Promise.all(deleteImages.map(function (deleteImage) { return __awaiter(void 0, void 0, void 0, function () {
                        var deleteImageRef;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    deleteImageRef = (0, storage_1.ref)(storage, deleteImage);
                                    return [4 /*yield*/, (0, storage_1.deleteObject)(deleteImageRef)];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); }))];
            case 2:
                _d.sent();
                return [3 /*break*/, 4];
            case 3:
                err_1 = _d.sent();
                console.log('Error: Delete Image', err_1);
                return [3 /*break*/, 4];
            case 4:
                createImages = function () { return __awaiter(void 0, void 0, void 0, function () {
                    var _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                _a = addImages;
                                if (!_a) return [3 /*break*/, 2];
                                return [4 /*yield*/, Promise.all(addImages.map(function (item) { return __awaiter(void 0, void 0, void 0, function () {
                                        var uploadedMedia;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    if (!item.file) return [3 /*break*/, 2];
                                                    return [4 /*yield*/, uploadMedia(item.file)];
                                                case 1:
                                                    uploadedMedia = _a.sent();
                                                    return [2 /*return*/, uploadedMedia === null || uploadedMedia === void 0 ? void 0 : uploadedMedia.url];
                                                case 2: return [2 /*return*/];
                                            }
                                        });
                                    }); }))];
                            case 1:
                                _a = (_b.sent());
                                _b.label = 2;
                            case 2: return [2 /*return*/, _a];
                        }
                    });
                }); };
                return [4 /*yield*/, createImages()];
            case 5:
                addedImages = _d.sent();
                newImages = __spreadArray(__spreadArray([], unchangeImages, true), addedImages, true);
                unchangeVideos = videos
                    .filter(function (video) { return video.action === 'UNCHANGE'; })
                    .map(function (video) { return ({
                    caption: video.caption,
                    fileName: video.fileName,
                    thumbnailUrl: video.thumbnailUrl,
                    url: video.url,
                }); });
                addVideos = videos.filter(function (video) { return video.action === 'ADD'; });
                deleteVideos = videos.filter(function (video) { return video.action === 'REMOVE'; }).map(function (video) { return video.url; });
                _d.label = 6;
            case 6:
                _d.trys.push([6, 8, , 9]);
                return [4 /*yield*/, Promise.all(deleteVideos.map(function (deleteVideo) { return __awaiter(void 0, void 0, void 0, function () {
                        var deleteVideoRef;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    deleteVideoRef = (0, storage_1.ref)(storage, deleteVideo);
                                    return [4 /*yield*/, (0, storage_1.deleteObject)(deleteVideoRef)];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); }))];
            case 7:
                _d.sent();
                return [3 /*break*/, 9];
            case 8:
                err_2 = _d.sent();
                console.log('Error: Delete Video', err_2);
                return [3 /*break*/, 9];
            case 9:
                createVideos = function () { return __awaiter(void 0, void 0, void 0, function () {
                    var _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                _a = addVideos;
                                if (!_a) return [3 /*break*/, 2];
                                return [4 /*yield*/, Promise.all(addVideos.map(function (item) { return __awaiter(void 0, void 0, void 0, function () {
                                        var uploadedMedia;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    if (!item.file) return [3 /*break*/, 2];
                                                    return [4 /*yield*/, uploadMedia(item.file)];
                                                case 1:
                                                    uploadedMedia = _a.sent();
                                                    return [2 /*return*/, uploadedMedia];
                                                case 2: return [2 /*return*/];
                                            }
                                        });
                                    }); }))];
                            case 1:
                                _a = (_b.sent());
                                _b.label = 2;
                            case 2: return [2 /*return*/, _a];
                        }
                    });
                }); };
                return [4 /*yield*/, createVideos()];
            case 10:
                addedVideos = _d.sent();
                newVideos = __spreadArray(__spreadArray([], unchangeVideos, true), addedVideos, true);
                _d.label = 11;
            case 11:
                _d.trys.push([11, 13, , 14]);
                faqData = __assign(__assign({}, data), { images: newImages, videos: newVideos });
                return [4 /*yield*/, (0, firestore_1.updateDoc)(faqDocRef, faqData)];
            case 12:
                _d.sent();
                return [3 /*break*/, 14];
            case 13:
                err_3 = _d.sent();
                console.log(err_3);
                throw err_3;
            case 14: return [2 /*return*/];
        }
    });
}); });
exports.deleteKnowledge = (0, toolkit_1.createAsyncThunk)('knowledge/delete', function (arg, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var state, companyID, baseFAQColRef, faqID;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                state = thunkAPI.getState();
                companyID = state.setting.activeWorkspaceID;
                baseFAQColRef = (0, firestore_1.collection)(firestore, 'companies', companyID, 'faqs');
                faqID = arg.faqID;
                return [4 /*yield*/, (0, firestore_1.deleteDoc)((0, firestore_1.doc)(baseFAQColRef, faqID))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); });
exports.archiveKnowledge = (0, toolkit_1.createAsyncThunk)('knowledge/archive', function (arg, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var state, companyID, isArchived, faqID, baseFAQColRef;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                state = thunkAPI.getState();
                companyID = state.setting.activeWorkspaceID;
                isArchived = arg.isArchived, faqID = arg.faqID;
                baseFAQColRef = (0, firestore_1.collection)(firestore, 'companies', companyID, 'faqs');
                return [4 /*yield*/, (0, firestore_1.updateDoc)((0, firestore_1.doc)(baseFAQColRef, faqID), {
                        isArchived: isArchived,
                    })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); });
exports.helpfulKnowledge = (0, toolkit_1.createAsyncThunk)('knowledge/changeHelpful', function (arg, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var state, isHelpful, faqID, companyID, uid, faq, helpfulNo, helpfulYes, helpfulNoNew, helpfulYesNew, baseFAQColRef;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                state = thunkAPI.getState();
                isHelpful = arg.isHelpful, faqID = arg.faqID;
                companyID = state.setting.activeWorkspaceID;
                uid = (_a = state.me.details) === null || _a === void 0 ? void 0 : _a.uid;
                faq = state.faq.faqs.find(function (faq) { return faq.faqId === faqID; });
                helpfulNo = (_b = faq === null || faq === void 0 ? void 0 : faq.helpfulNo) !== null && _b !== void 0 ? _b : [];
                helpfulYes = (_c = faq === null || faq === void 0 ? void 0 : faq.helpfulYes) !== null && _c !== void 0 ? _c : [];
                helpfulNoNew = helpfulNo.filter(function (id) { return id !== uid; });
                helpfulYesNew = helpfulYes.filter(function (id) { return id !== uid; });
                if (uid && isHelpful === true) {
                    helpfulYesNew.push(uid);
                }
                else if (uid && isHelpful === false) {
                    helpfulNoNew.push(uid);
                }
                baseFAQColRef = (0, firestore_1.collection)(firestore, 'companies', companyID, 'faqs');
                return [4 /*yield*/, (0, firestore_1.updateDoc)((0, firestore_1.doc)(baseFAQColRef, faqID), {
                        helpfulNo: helpfulNoNew,
                        helpfulYes: helpfulYesNew,
                        updatedAt: firestore_1.Timestamp.now(),
                    })];
            case 1: return [2 /*return*/, _d.sent()];
        }
    });
}); });
var initialState = {
    initialised: false,
    faqs: [],
};
var faqSlice = (0, toolkit_1.createSlice)({
    name: 'faq',
    initialState: initialState,
    reducers: {
        setFaqs: {
            reducer: function (state, action) {
                // console.log('prepare_setFaqs:', action.payload);
                if (action.payload) {
                    state.faqs = action.payload;
                    state.initialised = true;
                }
            },
            prepare: function (payload) {
                // console.log('prepare_setFaqs:', payload);
                if (payload) {
                    var faqModels = payload.map(function (faq) {
                        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
                        return {
                            faqId: faq.faqId,
                            answer: (_a = faq.answer) !== null && _a !== void 0 ? _a : '',
                            question: (_b = faq.question) !== null && _b !== void 0 ? _b : '',
                            tags: (_c = faq.tags) !== null && _c !== void 0 ? _c : [],
                            categories: (_d = faq.categories) !== null && _d !== void 0 ? _d : [],
                            companyID: (_e = faq.companyID) !== null && _e !== void 0 ? _e : '',
                            companyName: (_f = faq.companyID) !== null && _f !== void 0 ? _f : '',
                            branchID: (_g = faq.branchID) !== null && _g !== void 0 ? _g : '',
                            branches: (_h = faq.branches) !== null && _h !== void 0 ? _h : [],
                            displayName: (_j = faq.displayName) !== null && _j !== void 0 ? _j : '',
                            helpfulNo: (_k = faq.helpfulNo) !== null && _k !== void 0 ? _k : [],
                            helpfulYes: (_l = faq.helpfulYes) !== null && _l !== void 0 ? _l : [],
                            images: (_m = faq.images) !== null && _m !== void 0 ? _m : [],
                            videos: (_o = faq.videos) !== null && _o !== void 0 ? _o : [],
                            isAnon: (_p = faq.isAnon) !== null && _p !== void 0 ? _p : false,
                            isArchived: (_q = faq.isArchived) !== null && _q !== void 0 ? _q : false,
                            createdAt: faq.createdAt instanceof firestore_1.Timestamp ? (_s = (_r = faq.createdAt) === null || _r === void 0 ? void 0 : _r.toDate().toISOString()) !== null && _s !== void 0 ? _s : '' : '',
                            createdBy: (_t = faq.createdBy) !== null && _t !== void 0 ? _t : '',
                            createdByDisplayName: (_u = faq.createdByDisplayName) !== null && _u !== void 0 ? _u : '',
                            updatedAt: faq.updatedAt instanceof firestore_1.Timestamp ? (_w = (_v = faq.updatedAt) === null || _v === void 0 ? void 0 : _v.toDate().toISOString()) !== null && _w !== void 0 ? _w : '' : '',
                            updatedBy: (_x = faq.updatedBy) !== null && _x !== void 0 ? _x : '',
                            updatedByDisplayName: (_y = faq.updatedByDisplayName) !== null && _y !== void 0 ? _y : '',
                        };
                    });
                    return { payload: faqModels };
                }
                return { payload: null };
            },
        },
    },
});
var sortFaqByUpdateAt = function (a, b) {
    var timeB = (0, moment_1.default)(b.updatedAt).isValid() ? (0, moment_1.default)(b.updatedAt).toDate().getTime() : new Date().getTime();
    var timeA = (0, moment_1.default)(a.updatedAt).isValid() ? (0, moment_1.default)(a.updatedAt).toDate().getTime() : new Date().getTime();
    return timeB - timeA;
};
// Selectors
var selectAllCategories = function (state) { return state.faqCategory.faqCategories; };
var selectAllFaqs = function (state) {
    var result = __spreadArray([], state.faq.faqs, true).sort(sortFaqByUpdateAt);
    return result;
};
exports.selectAllFaqs = selectAllFaqs;
exports.selectAllFaqsWithCategories = (0, toolkit_1.createSelector)([selectAllCategories, exports.selectAllFaqs], function (categories, faqs) {
    var categoriesMapByItsIds = categories.reduce(function (_categoriesMapByItsIds, category) {
        var _a;
        return (__assign(__assign({}, _categoriesMapByItsIds), (_a = {}, _a[category.id] = category.name, _a)));
    }, {});
    return faqs.map(function (faq) { return (__assign(__assign({}, faq), { categoriesNames: (0, isEmpty_1.default)(faq.categories)
            ? ['Others']
            : faq.categories.map(function (categoryId) { return categoriesMapByItsIds[categoryId]; }).filter(function (categoryName) { return categoryName; }) })); });
});
exports.selectAllFaqsForMobileApp = (0, toolkit_1.createSelector)([exports.selectAllFaqsWithCategories, settingSlice_1.selectActiveTeam], function (faqs, activeTeam) {
    return faqs.filter(function (faq) {
        var faqBranches = (faq === null || faq === void 0 ? void 0 : faq.branches.length) ? faq === null || faq === void 0 ? void 0 : faq.branches : [activeTeam === null || activeTeam === void 0 ? void 0 : activeTeam.teamId]; // includes user's team by default (for old data)
        return faqBranches.includes(activeTeam === null || activeTeam === void 0 ? void 0 : activeTeam.teamId);
    });
});
var selectAllTeams = function (state) { return state.team.teams; };
exports.selectAllTeams = selectAllTeams;
exports.selectTags = (0, toolkit_1.createSelector)(exports.selectAllFaqs, function (faqs) {
    var tags = faqs
        .map(function (faq) { return faq.tags; })
        .reduce(function (a, b) {
        return __spreadArray(__spreadArray([], a, true), b, true);
    }, []);
    return Array.from(new Set(tags));
});
exports.selectAnsweredFaqs = (0, toolkit_1.createSelector)([exports.selectAllFaqsWithCategories, teamSlice_1.selectTeams], function (faqs, teams) {
    return faqs
        .filter(function (faq) { return faq.answer && !faq.isArchived; })
        .map(function (faq) {
        return __assign(__assign({}, faq), { createBy: faq.displayName, branchName: '', branches: mapBranchesIdToBranches(faq, teams), status: 'ANSWERED' });
    });
});
exports.selectArchivedFaqs = (0, toolkit_1.createSelector)([exports.selectAllFaqs, teamSlice_1.selectTeams], function (faqs, teams) {
    return faqs
        .filter(function (faq) { return faq.isArchived; })
        .map(function (faq) {
        return __assign(__assign({}, faq), { createBy: faq.displayName, branchName: '', branches: mapBranchesIdToBranches(faq, teams), status: (faq === null || faq === void 0 ? void 0 : faq.answer) ? 'ANSWERED' : 'UNANSWERED' });
    });
});
exports.selectUnansweredFaqs = (0, toolkit_1.createSelector)([exports.selectAllFaqsWithCategories, teamSlice_1.selectTeams], function (faqs, teams) {
    return faqs
        .filter(function (faq) { return !faq.answer && !faq.isArchived; })
        .map(function (faq) {
        var _a;
        var branchID = (_a = faq.branchID) !== null && _a !== void 0 ? _a : '';
        var branch = teams.find(function (team) { return team.teamId === branchID; });
        return __assign(__assign({}, faq), { createBy: faq.displayName, branchName: branch && branch.name ? branch.name : '', branches: mapBranchesIdToBranches(faq, teams), status: 'UNANSWERED' });
    });
});
exports.selectFAQByID = (0, toolkit_1.createSelector)([exports.selectAllFaqs, teamSlice_1.selectTeams], function (faqs, teams) {
    return function callbackFunction(faqId) {
        var _a;
        var faq = faqs.find(function (faq) { return faq.faqId === faqId; });
        var branchID = (_a = faq === null || faq === void 0 ? void 0 : faq.branchID) !== null && _a !== void 0 ? _a : '';
        var branch = teams.find(function (team) { return team.teamId === branchID; });
        if (faq) {
            return __assign(__assign({}, faq), { createBy: faq.displayName, branchName: branch === null || branch === void 0 ? void 0 : branch.name, branches: mapBranchesIdToBranches(faq, teams), status: (faq === null || faq === void 0 ? void 0 : faq.answer) ? 'ANSWERED' : 'UNANSWERED' });
        }
        else
            return null;
    };
});
var mapBranchesIdToBranches = function (faq, teams) {
    if (faq === null || faq === void 0 ? void 0 : faq.branches.length)
        return teams.filter(function (team) { return faq === null || faq === void 0 ? void 0 : faq.branches.includes(team.teamId); });
    else
        return teams; // defaults to all teams for old data
};
// Actions
exports.setFaqs = faqSlice.actions.setFaqs;
exports.default = faqSlice.reducer;
